import ExpandableSection from "../component/_expandableSection";
document.addEventListener('DOMContentLoaded', function() {
    new ExpandableSection(
        '.js-section-roadmap-data-sources-block__inner',
        '.js-section-roadmap-data-sources-block__title-container',
        '.js-section-roadmap-data-sources-block__data-sources',
        '.js-section-roadmap-data-sources-block__chevron',
        false,
        true,
        false,
        true
    );

    if(document.querySelector('.section-roadmap-data-sources-block__data-sources-content')) {
        var tags = document.querySelectorAll('.js-section-roadmap-data-sources-block__tag');
        var contentContainer = document.querySelector('.section-roadmap-data-sources-block__data-sources-content');

        var defaultContent = contentContainer.innerHTML;
        var firstTagName = tags[0].textContent.trim();

        tags.forEach(function (tag) {
            tag.addEventListener('click', function () {
                // Usuń klasę aktywną z wszystkich tagów
                tags.forEach(function (t) {
                    t.classList.remove('section-roadmap-data-sources-block__tag--active');
                });

                // Dodaj klasę aktywną do klikniętego tagu
                tag.classList.add('section-roadmap-data-sources-block__tag--active');

                var tagName = tag.textContent.trim();
                if (tagName === firstTagName) {
                    contentContainer.innerHTML = defaultContent;
                } else if (tagDataSources[tagName]) {
                    var dataSources = tagDataSources[tagName].data_sources;
                    contentContainer.innerHTML = '';
                    dataSources.forEach(function (category) {
                        var categoryDiv = document.createElement('div');
                        categoryDiv.classList.add('section-roadmap-data-sources-block__data-category', 'text-center', 'col-lg-3', 'pb-p-64');

                        if (category.source_category_icon) {
                            var img = document.createElement('img');
                            img.src = category.source_category_icon;
                            img.alt = category.source_category_icon_alt;
                            img.classList.add('img-fluid', 'section-roadmap-data-sources-block__data-icon', 'pt-p-24', 'pt-p-lg-0');
                            categoryDiv.appendChild(img);
                        }

                        var h4 = document.createElement('h4');
                        h4.classList.add('section-roadmap-data-sources-block__category-title', 'mb-p-24', 'mt-p10');
                        h4.textContent = category.source_category;
                        categoryDiv.appendChild(h4);

                        var ul = document.createElement('ul');
                        ul.classList.add('section-roadmap-data-sources-block__source-list');

                        category.sources.forEach(function (sourceName) {
                            var li = document.createElement('li');
                            li.classList.add('section-roadmap-data-sources-block__source-item', 'text-start', 'mb-p-lg-10');
                            li.textContent = sourceName;
                            ul.appendChild(li);
                        });

                        categoryDiv.appendChild(ul);
                        contentContainer.appendChild(categoryDiv);
                    });
                } else {
                    contentContainer.innerHTML = '';
                }
            });
        });

    const dataSourcesInner = document.querySelector('.js-section-roadmap-data-sources-block__data-sources');
    const imageElement = document.querySelector('.section-roadmap-data-sources-block__image');

    // Function to handle the style change only on desktop
    function handleHeightChange() {
        if (window.innerWidth > 768) { // Check if it's desktop view
            if (dataSourcesInner.style.height === '0px') {
                imageElement.style.display = 'none';
            } else if (dataSourcesInner.style.height === 'auto') {
                imageElement.style.display = 'block';
            }
        } else {
            imageElement.style.display = 'none'; // Hide the image on mobile view
        }
    }

    // Observe mutations in the style attribute
    const observer = new MutationObserver(handleHeightChange);

    // Start observing the target element
    observer.observe(dataSourcesInner, { attributes: true, attributeFilter: ['style'] });

    // Call the handler initially to set the correct display value
    handleHeightChange();

    // Re-run `handleHeightChange` on resize to adjust on window size change
    window.addEventListener('resize', handleHeightChange);
    }
});
